export class W3CardStack {
  private container: HTMLElement;
  private tabs: NodeListOf<Element>;
  private contents: NodeListOf<Element>;

  constructor(container: HTMLElement) {
    this.container = container;
    this.tabs = this.container.querySelectorAll(".tab");
    this.contents = this.container.querySelectorAll(".card-stack-tab-content");
    this.initTabs();
  }

  private initTabs(): void {
    this.tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        this.onTabClick(tab);
      });
      // Setze das erste Tab und dessen Inhalt als aktiv
      if (index === 0) {
        tab.classList.add("active");
        this.contents[index].classList.add("active");
        this.contents[index].style.display = "grid";
        this.contents[index].style.opacity = "1";
      } else {
        this.contents[index].style.display = "none";
        this.contents[index].style.opacity = "0";
      }
    });
  }

  private onTabClick(clickedTab: Element): void {
    this.tabs.forEach((tab) => {
      tab.classList.remove("active");
    });

    this.contents.forEach((content) => {
      content.classList.remove("active");
      content.style.display = "none";
      content.style.opacity = "0";
    });

    clickedTab.classList.add("active");
    const tabTitle = clickedTab.textContent || "";
    const targetId = `#tab-${this.sanitizeTitle(tabTitle)}`;
    const targetContent = this.container.querySelector(targetId);

    if (targetContent) {
      targetContent.classList.add("active");
      targetContent.style.display = "grid";
      setTimeout(() => {
        // Kurze Verzögerung, um den Übergang sichtbar zu machen
        targetContent.style.opacity = "1";
      }, 10);
    }
  }

  private sanitizeTitle(title: string): string {
    // Konvertiere den Titel zu einem URL-sicheren String, indem nicht-alphanumerische Zeichen entfernt werden
    return title
      .normalize("NFD") // Zerlegt den String in Basiszeichen und kombinierende Zeichen
      .replace(/[\u0300-\u036f]/g, "") // Entfernt diakritische Zeichen
      .toLowerCase() // Konvertiert den Text in Kleinbuchstaben
      .trim() // Entfernt Leerzeichen am Anfang und am Ende
      .replace(/\s+/g, "-") // Ersetzt alle Arten von Leerzeichen durch '-'
      .replace(/&/g, "") // Ersetzt '&' durch ''
      .replace(/[^\w\-]+/g, "") // Entfernt alle nicht Wort-Zeichen (Buchstaben, Zahlen und Bindestriche)
      .replace(/\-\-+/g, "-"); // Ersetzt mehrfache Bindestriche durch einen einzelnen Bindestrich
  }
}
